/* eslint-disable-next-line import/prefer-default-export */
export function delNull(params) {
  const result = {};
  if (params !== null && typeof params === 'object') {
    Object
      .keys(params)
      .forEach((key) => {
        const val = params[key];
        if (typeof val === 'undefined'
        || val === null) {
          return;
        }
        result[key] = val;
      });
  }
  return result;
}
